import * as React from "react";
import {cx} from "emotion";

import "./date-picker-2.scss";

import {cs}                     from "../../react/chain-services";
import {scopedState}            from "../../react/scoped-state";
import {stateChangeNestedValue} from "../../react/state-change-nested-value";
import {UseState}               from "../../react/use-state";
import {gt, lt, today}          from "../../utils/date-object";
import {chain}                  from "../../utils/fs";
import {Calendar}               from "../calendar/calendar/calendar";
import {MonthYearPanel}         from "../calendar/month-year-panel/month-year-panel";
import {Dropdown}               from "../dropdown/dropdown";

export const DatePicker2 = ({
    className=undefined,
    disabled=false,
    hasError = false,
    state,
    minDate=undefined,
    maxDate=undefined,
    limitMonthDropdown=false,
    isDisabled=undefined,
    placeholder=undefined,
    dateFormat,
    xdQaName=undefined,
    xdQaType=undefined,
    readOnly=false,
    onClick=undefined,
    onBlur=undefined,
}) => cs(
    ["active", (_, next) => UseState({next})],
    ({active, }) => Dropdown({
        // forcedExpandLeft,
        minExpandHeight: 428,
        minExpandWidth: 312,
        renderToggle: ({showExpand, domRef}) => (
            <div
                className={cx("date-picker date-picker-8ub toggle", className, {hasError})}
                ref={domRef}
                onClick={() => {
                    !disabled && showExpand(true)
                    if(onClick) {
                        onClick()
                    }
                }}
                onBlur={() => onBlur && onBlur()}
            >
                <input {...{
                    disabled: disabled,
                    placeholder: placeholder ?? dateFormat.pattern,
                    value: active.value?.text ?? (state.value && dateFormat.formatDate(state.value) || ""),
                    onChange: (e) => {
                        const value = e.target.value;

                        if (value === "") {
                            state.onChange(null);
                            stateChangeNestedValue(active, ["text"], () => null);
                        } else {
                            const parsedDate = dateFormat.parseDate(value);
                            if (parsedDate) {
                                state.onChange(parsedDate);
                                stateChangeNestedValue(active, ["text"], () => value);
                            } else {
                                stateChangeNestedValue(active, ["text"], () => value);
                            }
                        }
                    },
                    onBlur: () => active.change((a) => !a ? a : {...a, text: null}),
                    "xd-qa-type": xdQaType ?? "text_field",
                    "xd-qa-name": xdQaName,
                    readOnly: readOnly,
                }}/>
                <i className="fa fa-calendar" xd-qa-type="icon" xd-qa-name={xdQaName + " Calendar"} />
            </div>
        ),
        renderExpand: ({position, close, domRef}) => (
            <div
                className={cx("date-picker-8ub expand", {capture: false})}
                ref={domRef}
            >
                <div
                    className={cx("box")}
                    style={{...position}}
                    xd-qa-type="card" xd-qa-name={xdQaName + " Calendar"}
                >
                    {MonthYearPanel({
                        minMonthYear: {year: minDate?.year, month: limitMonthDropdown ? minDate?.month : 1},
                        maxMonthYear: {year: maxDate?.year, month: limitMonthDropdown ? maxDate?.month : 12},
                        monthYear: chain(
                            scopedState(active, ["monthYear"]),
                            (_) => ({..._, value: _?.value ?? state.value ?? today()})
                        ),
                    })}
                    {Calendar({
                        startDate: state.value,
                        endDate  : state.value,
                        monthYear: active.value?.monthYear ?? state.value ?? today(),
                        isDisabled: (minDate || maxDate) ? ((date) => {
                            if (isDisabled?.(date)) {
                                return true;
                            }
                            if (minDate && lt(date, minDate)) {
                                return true;
                            }
                            if (maxDate && gt(date, maxDate)) {
                                return true;
                            }
                            return false;
                        }) : null,
                        onSelect: (d) => {
                            state.onChange(d);
                            close();
                        },
                    })}
                </div>
            </div>
        ),
    }),
);
